import React from "react"

// import { ReactComponent as LogoSVG } from "assets/avtolog.svg"
// import { ReactComponent as LogoSVG } from "assets/avtolog_logo_black_title.svg"
import { ReactComponent as LogoSVG } from "assets/avtolog_logo_nov_2020-03-03-04-04.svg"

import "./Logo.sass"

export default (props) => <LogoSVG className="Logo" {...props} />
